/* eslint-disable */
import React from 'react';
import DynamicNumber from './dynamicNumber';

class DynamicNumberComponent extends React.Component {

  static propTypes = {
    value: React.PropTypes.oneOfType([
      React.PropTypes.string,
      React.PropTypes.number,
      (props, propName) => {
        if(props[propName] != ''){
          return new Error('value must be a number or empty string');
        }
      }
    ]),
    integer: React.PropTypes.number,
    fraction: React.PropTypes.number,
    positive: React.PropTypes.bool,
    negative: React.PropTypes.bool,
    name: React.PropTypes.string,
    disabled: React.PropTypes.bool,
    maxValue: React.PropTypes.number,
    minValue: React.PropTypes.number,
    nullAsDefault: React.PropTypes.bool,
    separator: (props, propName) => {
      if(props[propName] !== undefined && props[propName] !== ',' && props[propName] !== '.') {
        return new Error('separator have to be comma or dot char');
      }
    },
    thousand: (props, propName) => {
      if(props[propName] !== undefined && props[propName] !== true && props[propName] !== false && props[propName] !== ' ') {
        return new Error('thousand have to be bool value or space character');
      }
    }
  }

  constructor(props) {
    super(props);

    this.dynamicNumber = new DynamicNumber();
    this.dynamicNumber.separator = this.props.separator;
    this.dynamicNumber.integer = this.props.integer;
    this.dynamicNumber.fraction = this.props.fraction;
    this.dynamicNumber.positive = this.props.positive;
    this.dynamicNumber.negative = this.props.negative;
    this.dynamicNumber.thousand = this.props.thousand;
    this.dynamicNumber.maxValue = this.props.maxValue;
    this.dynamicNumber.minValue = this.props.minValue;
    this.calculator = this.dynamicNumber.clone();
    if((this.props.nullAsDefault && !this.props.value && this.props.value !== 0)
      || (this.props.value === '' && props.fraction!==2)) {
      this.state = {
        modelValue: '',
        viewValue: ''
      }
    } else {
      const fractionValue = parseFloat( props.value || 0, 10).toFixed(props.fraction || 0)
      this.calculator.calculate(fractionValue, fractionValue, '0');
      this.state = {
        modelValue: this.calculator.modelValue,
        viewValue: this.calculator.viewValue
      }
    }
    this.onChange= this.onChange.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.value===this.props.value){
      return;
    }
    if(nextProps.value === ''){
      this.state = {
        modelValue: '',
        viewValue: ''
      }
    } else if(nextProps.value !== undefined){
      this.calculator.calculate(nextProps.value, nextProps.value, 0);

      if (this.state.modelValue != this.calculator.modelValue) {
        this.state = {
          modelValue: this.calculator.modelValue,
          viewValue: this.calculator.viewValue
        }
      }
    }
  }

  shouldComponentUpdate(props, state) {
    if (JSON.stringify(state)!=JSON.stringify(this.state)
     ||  JSON.stringify(props)!=JSON.stringify(this.props)) {
      return true;
    }
    return false;
  }

  onChange(evt) {
    var target = evt.target;
    this.dynamicNumber.calculate(evt.target.value, this.state.modelValue, this.state.viewValue,
      target.selectionStart, this.props.nullAsDefault);

    var modelValue = this.dynamicNumber.modelValue;
    var viewValue = this.dynamicNumber.viewValue;

    if((modelValue!=this.state.modelValue || viewValue!=this.state.viewValue) && this.props.onChange) {
      this.props.onChange(evt, modelValue, viewValue);
    }

    let isStale = true;
    if (this.state.viewValue != viewValue) {
      isStale = false;
    }

    this.setState({
      modelValue: modelValue,
      viewValue: viewValue
    }, () => {
      //after value change we set cursor position
      if(target.selectionStart !== undefined && target.selectionStart !== null) {
        setTimeout(() => {
          target.selectionStart = target.selectionEnd =
            (isStale
              ? this.dynamicNumber.cursorPosition - 1
              : this.dynamicNumber.cursorPosition
            );
        }, 0);
      }

    });
  }

  render() {
    let { disabled } = this.props;
    if (disabled === undefined) disabled = this.context.disabled;
    return (
      <div
      title = { disabled ? this.state.viewValue : undefined }
      className = { disabled ? 'disabled-fancy-input fancy-input' : 'fancy-input' }
      style={this.props.currency ? {display:'flex', alignItems: 'center' } : {}}
      >
        {this.props.currency?
          <div>
           {this.props.currency}
          </div>:''}
        <input
          type="text"
          disabled={disabled}
          name={`_${this.props.name}`}
          id={`_${this.props.id}`}
          placeholder={this.props.placeholder}
          className={this.props.className}
          value={this.state.viewValue}
          data-modelValue={this.state.modelValue}
          data-custom={this.props.customData}
          onChange={this.onChange}
          style={this.props.currency? {...this.props.style,paddingLeft:10} : this.props.currency }
          onClick={this.props.onClick}
        />
        <input
          type="text"
          name={this.props.name}
          value={this.state.modelValue}
          style={{display:'none'}}
          id={this.props.id}
          onChange={()=>({})}
        />
      </div>);
  }
}

DynamicNumberComponent.contextTypes = {
  disabled: React.PropTypes.bool,
};

export default DynamicNumberComponent;
